import React, { useEffect, useCallback, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { Checkbox } from "antd";
import Webcam from "react-webcam";
import CaptureIcon from "../../assets/images/captureIcon.svg";
import { HiArrowLongRight } from "react-icons/hi2";
import { FaArrowLeft } from "react-icons/fa6";

function Step1(props: any) {
  const webcamRef: any = useRef(null);

  useEffect(() => {
    if (!navigator.mediaDevices?.enumerateDevices) {
      console.log("enumerateDevices() not supported.");
    } else {
      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          devices.forEach((device) => {});
        })
        .catch((err) => {
          console.error(`${err.name}: ${err.message}`);
        });
    }
  }, []);

  const capture = useCallback(() => {
    try {
      const imageSrc = webcamRef.current.getScreenshot();
      var blob = new Blob([imageSrc], { type: "image/jpeg" });
      const myNewFile = new File([blob], "babu" + "N.png", { type: blob.type });
      console.log("myNewFile", myNewFile);
      var objectUrl = URL.createObjectURL(myNewFile);
      console.log("objectUrl", objectUrl);
      props.onChange(objectUrl);
    } catch (err) {
      console.log(err);
    }
  }, [webcamRef]);

  const videoConstraints = {
    height: 320,
    width: 320,
    facingMode: "user",
  };

  return (
    <>
      <div className="FaceIdScreen-box1">
        <div className="FaceIdScreen-box3">
          <div className="FaceIdScreen-box4">
            <div className="FaceIdScreen-box5">
              <Webcam
                audio={false}
                screenshotFormat="image/jpeg"
                ref={webcamRef}
                mirrored={true}
                height={320}
                width={320}
                videoConstraints={videoConstraints}
                style={{ borderRadius: "100%" }}
              />
            </div>
          </div>
        </div>

        <div className="FaceIdScreen-txt1">
          Position your face inside the circle
        </div>
        <div className="FaceIdScreen-box2">
          <Checkbox>
            I consent to the matching of my biometric data, for the purpose of
            identity verification.
          </Checkbox>
        </div>

        <div>
          <Row>
            <Col sm={4} xs={1}>
              <div className="back-button" onClick={() => props.goback()}>
                <FaArrowLeft />
              </div>
            </Col>
            <Col sm={4} xs={11}>
              <div className="button-primary" onClick={capture}>
                <div>
                  <img src={CaptureIcon} className="FaceIdScreen-CaptureIcon" />
                </div>
                <div>CAPTURE MY FACE</div>
                <div>
                  <HiArrowLongRight className="FaceIdScreen-BsArrowRight" />
                </div>
              </div>
            </Col>
            <Col sm={4}></Col>
          </Row>
        </div>
      </div>
    </>
  );
}

export default Step1;
